import { toast } from 'sonner';

// The AI endpoints (`/v1/aiprovider/*`) answer HTTP 200 with
// `{ error: 0, status: 404, message }` when the AI model is down.
export const AI_MODEL_UNAVAILABLE_STATUS = 404;

const FALLBACK_MESSAGE = 'Investigation agent is currently unavailable';

// one id, so a re-render or a second AI panel never stacks copies
const TOAST_ID = 'ai-model-unavailable';

export const isAiModelUnavailable = body => Boolean(body) && !body.error && body.status === AI_MODEL_UNAVAILABLE_STATUS;

// Shows the backend's message as a toast and returns it.
export const notifyAiModelUnavailable = body => {
  const message = body?.message || FALLBACK_MESSAGE;
  toast.info(message, { id: TOAST_ID });
  return message;
};

// For react-query callers: toasts, then throws, so the "unavailable"
// answer is never cached as if it were the analysis. Pair it with
// `retry: retryUnlessAiModelUnavailable`.
export const throwIfAiModelUnavailable = body => {
  if (isAiModelUnavailable(body)) {
    const error = new Error(notifyAiModelUnavailable(body));
    error.aiModelUnavailable = true;
    throw error;
  }
  return body;
};

// The app's default for other failures (`retry: 2` in index.tsx), but
// a down model is not asked again: the user already has the answer.
const DEFAULT_RETRIES = 2;
export const retryUnlessAiModelUnavailable = (failureCount, error) =>
  !error?.aiModelUnavailable && failureCount < DEFAULT_RETRIES;
